<mat-dialog-content>
  <section *ngIf="processing">
    <h2>Loading...</h2>
    <mat-progress-bar mode="indeterminate" color="primary" aria-label="Loading..."></mat-progress-bar>
    <br />
  </section>
  
  <form #form="ngForm" (ngSubmit)="onSubmit()">
  <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
    <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
      <h2 class="noMarginHeader"><mat-icon>delete</mat-icon> Delete Sample {{sampleViewModel?.sampleId}}</h2>
    </div>
    <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="end">
      <button type="submit" mat-raised-button color="primary" title="Yes - Delete" *ngIf="!saved">Yes - Delete</button>
      &nbsp;&nbsp;
      <button mat-button mat-dialog-close="Cancel" mat-raised-button color="basic" aria-label="Cancel" *ngIf="!saved">Cancel</button>
      <button mat-button mat-dialog-close="Cancel" mat-raised-button color="basic" aria-label="Close"*ngIf="saved">Close</button>
    </div>
  </div>
</form>
<br />
<div fxLayout="column" *ngIf="sampleViewModel != undefined">
  <mat-card *ngIf="saved">
    <span class="success">Sample {{sampleViewModel?.sampleId}} has been deleted</span>
  </mat-card>
  <mat-card *ngIf="!saved">
    Address: {{sampleViewModel.wellAddress1}}
    <br />
    City: {{sampleViewModel.wellCity}}
    <br />
    Zip: {{sampleViewModel.wellZip}}
    <br />
    County: {{sampleViewModel.wellCounty}}
    <br />
    Well Log: {{sampleViewModel.wellId}}
    <br />
    Well Tag: {{sampleViewModel.wellTag}}
    <br />
    Sample Tests: {{sampleViewModel.parameterResults.length}}    
    <br /><br />
    Are you sure you want to delete Sample <strong>{{sampleViewModel.sampleId}}</strong>?
  </mat-card>
</div>
</mat-dialog-content>